<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{ translations('navbar.budget_control') }}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('navbar.enter_shipping_cost') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap">
      <div class="left-container">
          <div class="form-inline mb-4">
            <div class="form-group">
              <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#CostBudgetYearModal">
                {{ translations('budget.add_new_fiscal_year') }}</button>
            </div>
          </div>
          <h5 class="mb-3">Information</h5>
          <table class="table table-sm table-borderless table-information">
            <tbody>
              <tr>
                <th>{{ translations('budget.fiscal_year') }}</th>
                <td>
                  <select v-model="selectedYear" class="custom-select" @change="listBudgets(true)">
                    <option v-for="(year, i) in years" :key="i" :value="year" >{{year}}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="form-inline">
            <div class="form-group">
              <a class="btn btn-link btn-sm text-danger" href="#" @click="deleteYear()">{{ translations('common.delete') }}</a>
            </div>
          </div>
        </div>
        <div class="right-container">
          <h5 class="font-weight-bold mb-3">{{ translations('budget.domestic_shipping_fee') }}</h5>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheckTax" ref="defaultCheckTax" v-model="taxIncluded" @change="toggleTax()">
              <label class="form-check-label" for="defaultCheckTax">{{ translations('common.tax_included') }}</label>
            </div>
          </div>
          <div class="table-scroll mb-4">
            <table class="table table-sm table-striped">
              <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
              <thead>
                <tr>
                  <th class="width-20">{{ translations('budget.month') }}</th>
                  <th v-for="(contact, i) in contactNames" :key="i">{{contact}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(budget, i) in tempBudgets">
                  <tr :key="i">
                    <td>{{getMonthName(budget)}}</td>
                    <td v-for="(contact, i) in contactNames" :key="i"><button class="btn btn-link p-0" type="button" data-toggle="modal" data-target="#CostBudgetChangeModal" @click="updateCost(budget[contact])">{{ toVatFormat(budget[contact].cost, '-----') }}</button></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <CostBudgetYearModal />
      <CostBudgetChangeModal :cost="selectedCost" :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"/><!-- VAT -->
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import CostBudgetYearModal from '@/components/CostBudgetYearModal'
import CostBudgetChangeModal from '@/components/CostBudgetChangeModal'
import { mapState } from 'vuex'

export default {
  name: 'CostBudget',
  components: {
    VueElementLoading,
    CostBudgetYearModal,
    CostBudgetChangeModal
  },
  props: {},
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      isLoading: false,
      years: [],
      newAddedYears: [],
      selectedYear: 0,
      budgets: [],
      tempBudgets: [],
      isSearching: false,
      contactNames: [],
      selectedCost: {},
      monthNames: [
        '', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },
  created: async function () {
    this.isLoading = true
    this.getVatRate() // VAT
    this.loadYears()

    setTimeout(() => {
      this.isLoading = false
    }, 2000)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getMonthName (budget) {
      if (budget.month === 0) {
        return this.translations('budget.annual')
      } else {
        if (this.currentLanguage === 'en') {
          const monthNumber = parseInt(budget.month, 10)
          return this.monthNames[monthNumber]
        } else {
          const monthNumber = parseInt(budget.month, 10)
          return monthNumber + this.translations('budget.month')
        }
      }
    },
    async getVatRate () { // VAT
      try {
        let result = await this.$http.post(this.$api_url.vat_rate)
        console.log(JSON.stringify(result.data))
        if (result.data.status === true) {
          this.vatRate = result.data.vat_rate
          this.restoreTax()
        } else {
          this.$toastr.error('消費税率が取得できませんでした。', 'エラー')
          this.taxIncluded = false
          this.$refs['defaultCheckTax'].disabled = true
        }
      } catch (error) {
        console.log('CostBudget:getVatRate:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    restoreTax () { // VAT (rename *****)
      this.taxIncluded = this.$storage.get('CostBudget.taxIncluded', this.taxIncluded) ? this.$storage.get('CostBudget.taxIncluded', this.taxIncluded) : false
      console.log(this.taxIncluded)
    },
    toggleTax () { // VAT (rename *****)
      this.$storage.set('CostBudget.taxIncluded', this.taxIncluded)
      console.log(this.taxIncluded)
    },
    toVatFormat (target, noData = null, taxIncluded = null, vatRate = null) { // VAT OUTPUT
      if (target) {
        taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
        vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
        let tax = Math.round(target * (100 + vatRate) / 100)
        if (!taxIncluded) {
          return `${Number(target).toLocaleString()} (${Number(tax).toLocaleString()})`
        } else {
          return `${Number(tax).toLocaleString()} (${Number(target).toLocaleString()})`
        }
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    toVat (target, noData = null, taxIncluded = null, vatRate = null) { // VAT OUTPUT (Modal)
      if (target) {
        taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
        vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
        let tax = Math.round(target * (100 + vatRate) / 100)
        if (!taxIncluded) {
          return `${Number(target)}`
        } else {
          return `${Number(tax)}`
        }
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    noVatFormat (target, noData = null) { // VAT OUTPUT
      if (target) {
        return Number(target).toLocaleString()
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT
      target = target || 0
      taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },

    async loadYears () {
      try {
        let cList = await this.$http.post(this.$api_url.load_years)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'years', 'CostBudget:listYears')
        console.log('CostBudget:' + this.$api_url.load_years + ':row_response -- ', JSON.stringify($data))
        if ($data.success === true) {
          this.years = $data.data
          this.years = this.years.sort(function (a, b) {
            return b - a
          })
          this.selectedYear = this.years[0]
        } else {
          this.years = []

          // テストデータ
          this.selectedYear = (new Date()).getFullYear()
          for (let i = this.selectedYear; i > this.selectedYear - 5; i--) {
            this.years.push(i)
          }
          console.log('CostBudget:' + this.$api_url.load_years + ':ダミーデータ-- ', JSON.stringify(this.years))
        }
        await this.listBudgets(false)
      } catch (error) {
        console.log('CostBudget:listyears:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    addYear (year) {
      let alreadyAdded = false
      this.years.forEach(function (value) {
        if (value === year) {
          alreadyAdded = true
        }
      })

      if (alreadyAdded === false) {
        this.years.push(year)
        this.years = this.years.sort(function (a, b) {
          return b - a
        })
      }
    },

    refreshYear () {
      let $this = this
      this.years.forEach(function (value, index) {
        if (value === $this.selectedYear) {
          $this.years.splice(index, 1)
          $this.selectedYear = $this.years[0]
        }
      })
    },

    updateCost (budget) {
      this.selectedCost = {
        cost_id: budget.id,
        cost: this.toVat(budget.cost), // VAT (Modal) budget.cost,
        month: budget.month,
        warehouse_company_name: budget.warehouse_company_name
      }
    },

    async updateBudgetCost (budget) {
      try {
        let paramUpdate = {
          cost_id: budget.cost_id,
          cost: budget.cost
        }
        console.log('CostBudget:updateBudgetCost', JSON.stringify(paramUpdate))

        let updateBudgetCost = await this.$http.post(this.$api_url.cost_update, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(updateBudgetCost.data)
        console.log('CostBudget:updateBudgetCost: ', JSON.stringify($data))

        if ($data.success === true) {
          this.tempBudgets[Number(budget.month) - 1][budget.warehouse_company_name].cost = budget.cost
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('CostBudget:updateBudgetCost:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async listBudgets (isSearch) {
      try {
        let params = {
          year: this.selectedYear || (new Date()).getFullYear()
        }
        console.log('CostBudget:' + this.$api_url.cost_list + ':params  ', JSON.stringify(params))

        this.isSearching = isSearch

        let budgetList = await this.$http.post(this.$api_url.cost_list, params)

        console.log('CostBudget:' + this.$api_url.cost_list + ':row_response  ', JSON.stringify(budgetList))

        let $data = this.$invoiceTools.prepareResult(budgetList.data, 'list', 'CostBudget:listBudgets')

        console.log('CostBudget:' + this.$api_url.cost_list + ':data  ', JSON.stringify($data))

        if ($data.success === true) {
          this.budgets = $data.data
        } else {
          this.budgets = undefined
        }

        if (this.budgets === undefined) {
          // テストデータ
          // this.loadTestData()
        }

        this.fetchContactNames()
        this.changeBudgetFormat()

        console.log('CostBudget:listBudgets:list', JSON.stringify(this.budgets))
        console.log('CostBudget:listBudgets:afterChange', JSON.stringify(this.tempBudgets))
        console.log('CostBudget:listBudgets:contactNames', JSON.stringify(this.contactNames))

        this.isSearching = false
      } catch (error) {
        console.log('CostBudget:listBudgets:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async deleteYear () {
      this.$dialog.confirm('この年度を削除しますか?').then(async () => {
        try {
          this.isLoading = true

          let paramUpdate = {
            year: this.selectedYear
          }
          console.log('CostBudget:deleteYear', JSON.stringify(paramUpdate))

          let deleteYear = await this.$http.post(this.$api_url.cost_delete_year, paramUpdate)

          let $data = this.$invoiceTools.prepareResult(deleteYear.data)

          console.log('CostBudget:deleteYear: ', JSON.stringify($data))
          if ($data.success === true) {
            this.$toastr.success('年度の削除に成功しました。', 'Success')
            this.refreshYear()
          } else {
            this.$toastr.error($data.data, 'エラー')
            this.refreshYear()
          }
          this.isLoading = false
        } catch (error) {
          console.log('NewOrders:deleteYear:catch(error): ', JSON.stringify(error))
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    fetchContactNames () {
      this.contactNames = []
      let alreadyAdded = false
      let $this = this
      this.budgets.forEach(function (value) {
        alreadyAdded = false
        $this.contactNames.forEach(function (name) {
          if (name === value.warehouse_company_name) {
            alreadyAdded = true
          }
        })
        if (alreadyAdded === false) {
          $this.contactNames.push(value.warehouse_company_name)
        }
      })
    },

    changeBudgetFormat () {
      this.tempBudgets = []
      for (let i = 1; i <= 12; i++) {
        let budget = {
          month: i
        }

        for (let j = 0; j < this.contactNames.length; j++) {
          budget[this.contactNames[j]] = 0
        }

        this.budgets.forEach(function (value) {
          if (Number(value.month) === i) {
            if (value.cost === null) {
              value.cost = 0
            }
            budget[value.warehouse_company_name] = value
          }
        })

        this.tempBudgets.push(budget)
      }
    },

    // テストデータ
    loadTestData () {
      this.budgets = []
      for (let i = 1; i <= 3; i++) {
        for (let j = 1; j <= 12; j++) {
          this.budgets.push(this.loadSingleTestData(i, 'テストデータ' + i, j))
        }
      }
    },

    loadSingleTestData (wId, wName, month) {
      return {
        id: Math.floor(Math.random() * 1000),
        warehouse_company_id: wId,
        warehouse_company_name: wName,
        month: month,
        cost: Math.floor(Math.random() * 10000)
      }
    }
  }
}
</script>
